import React from "react";

interface LocationIconIconProps {
  width?: string;
  height?: string;
  className?: string;
}

export const LocationIcon: React.FC<LocationIconIconProps> = ({
  width = "24",
  height = "24",
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.2541 13.7421L2.53381 11.5859C2.38249 11.5395 2.24971 11.4465 2.15449 11.3201C2.05926 11.1936 2.00646 11.0403 2.00365 10.8821C2.00084 10.7239 2.04817 10.5688 2.13885 10.4391C2.22953 10.3094 2.35892 10.2117 2.5085 10.1599L19.0085 4.03994C19.1409 3.99493 19.2832 3.9878 19.4194 4.01937C19.5556 4.05095 19.6802 4.11996 19.7793 4.21863C19.8783 4.31729 19.9478 4.44168 19.98 4.57775C20.0121 4.71382 20.0055 4.85616 19.961 4.98869L13.841 21.4887C13.7893 21.6383 13.6916 21.7677 13.5619 21.8584C13.4322 21.949 13.2771 21.9964 13.1188 21.9935C12.9606 21.9907 12.8073 21.9379 12.6809 21.8427C12.5545 21.7475 12.4614 21.6147 12.4151 21.4634L10.2541 13.7421Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
